import React, { useState, useEffect } from 'react';
import '../styles/TourBanner.css';
import left from '../assets/Button - Next slide.png';
import right from '../assets/Button - Next slide-2.png';
import BASE_URL from '../config';

const TourBanner = ({ tour }) => {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [images, setImages] = useState([]);

  useEffect(() => {
    if (!tour?.ID) return;

    fetch(`${BASE_URL}/api/tour/${tour.ID}/images`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          const formattedImages = data.map((img, index) => ({
            src: img.url || img, // adapt to your API structure
            alt: img.title || `Image ${index + 1}`,
          }));
          setImages(formattedImages);
        } else {
          setImages([]);
        }
      })
      .catch(err => {
        console.error('Failed to load images:', err);
        setImages([]);
      });
  }, [tour?.ID]);

  const handleOpenGallery = () => setIsGalleryOpen(true);
  const handleCloseGallery = () => setIsGalleryOpen(false);
  const handlePreviousImage = () =>
    setCurrentImageIndex(currentImageIndex === 0 ? images.length - 1 : currentImageIndex - 1);
  const handleNextImage = () =>
    setCurrentImageIndex(currentImageIndex === images.length - 1 ? 0 : currentImageIndex + 1);

  const ImageWithFallback = ({ src, alt, className }) => {
    const [hasError, setHasError] = useState(false);

    if (!src || hasError) {
      return (
        <div
          className={className}
          style={{
            background: '#ccc',
            color: '#555',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '8px',
            fontSize: '14px',
          }}
        >
          No image available
        </div>
      );
    }

    return (
      <img
        src={src}
        alt={alt}
        className={className}
        onError={() => setHasError(true)}
      />
    );
  };

  // Ensure at least 4 placeholders to avoid errors
  const safeImages = [
    images[0] || { src: '', alt: 'No image' },
    images[1] || { src: '', alt: 'No image' },
    images[2] || { src: '', alt: 'No image' },
    images[3] || { src: '', alt: 'No image' },
  ];

  return (
    <div className="image-banner" style={{ margin: '20px' }}>
      <div className="image-grid">
        <div className="main-image-container">
          <ImageWithFallback
            src={safeImages[0].src}
            alt={safeImages[0].alt}
            className="main-image"
          />
          <div className="main-image-overlay">
            <div className="tour-title">{tour?.Name || 'Tour Title'}</div>
            <button className="view-gallery-button" onClick={handleOpenGallery}>
              View Gallery
            </button>
          </div>
        </div>

        <div className="small-images-column">
          <ImageWithFallback
            src={safeImages[1].src}
            alt={safeImages[1].alt}
            className="small-image"
          />
          <ImageWithFallback
            src={safeImages[2].src}
            alt={safeImages[2].alt}
            className="small-image"
          />
        </div>

        <div className="main-image-container">
          <ImageWithFallback
            src={safeImages[3].src}
            alt={safeImages[3].alt}
            className="main-image"
          />
        </div>
      </div>

      {isGalleryOpen && (
        <div className="gallery-modal" onClick={handleCloseGallery}>
          <div className="gallery-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-gallery" onClick={handleCloseGallery}>×</button>
            <button className="gallery-nav" onClick={handlePreviousImage}>
              <img src={left} alt="Previous" />
            </button>
            <ImageWithFallback
              src={images[currentImageIndex]?.src}
              alt={`Image ${currentImageIndex + 1}`}
              className="gallery-image"
            />
            <button className="gallery-nav" onClick={handleNextImage}>
              <img src={right} alt="Next" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TourBanner;
